<template>
  <div
    id="$address-book$"
    class="width-full height-full bg-F6F6F6 bt address-book"
  >
    <!-- 查看详情 -->
    <div v-if="showSelectDetail" class="width-full height-full fb fb-col">
      <div class="item-flex-1 scroll pt-12 pb-60" refs="scroller">
        <div v-if="(selectedMembers || []).length">
          <div
            v-for="item in selectedMembers"
            :key="item.tpId"
            class="bg-FFFFFF pl-16"
          >
            <div class="bg-FFFFFF h-68 fb fb-main-start fb-cross-center">
              <div class="head-img-text fb fb-main-center fb-cross-center">
                {{ nameLastTwoWords(item.memberName) }}
              </div>
              <div
                class="item-flex-1 height-full fb fb-main-between fb-cross-center"
              >
                <div class="item-flex-1">
                  <div class="fb fb-col fb-main-center p-9-0">
                    <div class="fb fb-main-start fb-cross-center mb-4">
                      <span class="font-34 pr-5 max-w-100 text-ellipsis">{{
                        item.memberName
                      }}</span>
                    </div>
                  </div>
                </div>
                <i
                  class="iconfont font-40 c-171A1D-40 mr-16"
                  @click="clearMember(item)"
                  >&#xe670;</i
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer fixed bottom-0 fb fb-main-center fb-cross-center">
        <common-button @click="clearData" type="add" class="mr-16"
          >清空</common-button
        >
        <common-button type="primary" @click="showSelectDetail = false"
          >确定</common-button
        >
      </div>
    </div>

    <!-- 通讯录页面 -->
    <div v-else class="width-full height-full fb fb-col">
      <!-- 成员搜索输入框 -->
      <common-search-input-box
        class="p-8-0 p-0-8 bg-FFFFFF"
        placeholder="搜索"
        :delay="1000"
        :searchValue="searchKey"
        @search="handlerToSearchMembers"
      ></common-search-input-box>

      <!-- 部门层级导航 -->
      <common-node-nav
        class="p-0-16"
        v-if="nodeNav.length > 0 && !searchKey"
        :nodeNav="nodeNav"
        @click="handlerBackToNode"
      ></common-node-nav>
      <!-- 全选 此处的全选只能选人 没有意义 去掉-->
      <!-- <div
        v-if="multiple && currentMembers.length"
        class="h-56 fb fb-row fb-start-center font-34 bg-FFFFFF p-0-16 mb-8"
      >
        <common-checkbox
          :isChecked="compuedIsSelectedAll"
          @click="handlerToChangeSelections"
          ><span class="ml-12">全选</span></common-checkbox
        >
      </div> -->
      <div class="item-flex-1 scroll">
        <!-- 搜索结果成员列表 -->
        <div v-show="searchKey" class="node-list h-full font-34">
          <div
            v-show="searchMembers.length === 0"
            class="mt-60 h-full c-171A1D-56 fb-col-center-center item-flex-1"
          >
            <i class="iconfont font-120 c-171A1D-28 mb-16">&#xe6fb;</i>
            <span class="font-26">没有符合搜索条件的记录</span>
          </div>
          <div
            class="fb fb-row fb-cross-center pl-16 bg-FFFFFF"
            v-for="(member, index) in searchMembers"
            @click="handlerChangeMemberSelections(member)"
            :key="index"
          >
            <div class="mr-12"
              ><span
                class="iconfont font-48"
                :class="member.selected ? 'c-006AFE' : 'c-171A1D-24'"
                >{{ member.selected ? '&#xe66e;' : '&#xe66f;' }}</span
              ></div
            >
            <div class="bb item-flex-1 fb fb-row fb-cross-center p-12-0">
              <div class="mr-12 font-24">
                <div
                  class="h-36 w-36 bg-006AFE c-FFFFFF bd-p-50 fb fb-cross-center fb-main-center"
                >
                  {{ nameLastTwoWords(member.memberName) }}
                </div>
              </div>
              <div class="item-flex-1">
                <div
                  class="width-full fb fb-cross-center pb-4 text-ellipsis font-34"
                >
                  <span>{{ member.memberName }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 子级部门列表、部门成员列表 -->
        <div
          v-show="
            !searchKey &&
            ((currentDepts || []).length || (currentMembers || []).length > 0)
          "
          class="node-list item-flex-1 bg-FFFFFF font-34"
        >
          <!-- 子级部门列表 -->
          <div
            v-for="node in currentDepts"
            class="fb-start-center h-56 lh-56 pl-16"
            :key="node.deptId"
          >
            <div
              class="bb item-flex-1 fb fb-cross-center fb-main-between pr-16"
            >
              <div class="item-flex-1 fb fb-cross-center hidden-x"
                ><span
                  :class="['text-ellipsis inline-block w-adapt-24', 'c-171A1D']"
                  >{{ node.deptName }}</span
                >
              </div>
              <div class="c-006AFE font-34">
                <span
                  class="bl-12 pl-9"
                  @click.stop="handlerToGetSubNodes(node)"
                >
                  <i class="iconfont">&#xe714;</i>下级
                </span>
              </div>
            </div>
          </div>
          <!-- 部门成员列表 -->
          <div
            class="fb fb-row fb-cross-center pl-16"
            v-for="member in currentMembers"
            @click="handlerChangeMemberSelections(member)"
            :key="member.tpId"
          >
            <div class="mr-12"
              ><span
                class="iconfont font-48"
                :class="member.selected ? 'c-006AFE' : 'c-171A1D-24'"
                >{{ member.selected ? '&#xe66e;' : '&#xe66f;' }}</span
              ></div
            >
            <div class="bb item-flex-1 fb fb-row fb-cross-center p-12-0">
              <div class="mr-12 font-32">
                <div
                  class="h-36 w-36 bg-006AFE c-FFFFFF bd-p-50 fb fb-cross-center fb-main-center"
                >
                  {{ nameLastTwoWords(member.memberName) }}
                </div>
              </div>
              <div class="item-flex-1">
                <div class="width-full fb fb-cross-center pb-4">
                  <span
                    class="font-34 max-w-180 inline-block text-ellipsis mr-5"
                    >{{ member.memberName }}</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="font-26 fb fb-cross-center fb-main-between h-60 bg-FFFFFF p-0-16 bt-8"
      >
        <div
          class="item-flex-1 c-006AFE text-ellipsis"
          @click.stop="showSelectDetail = true"
        >
          {{ computedSelectedText }}
          <i v-show="computedShowDetail" class="ml-8 c-006AFE iconfont font-38"
            >&#xe610;</i
          >
        </div>
        <div>
          <common-button
            type="primary"
            :styles="'font-24'"
            width="95"
            height="32"
            @click="handlerToSubmit"
            >确定</common-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import API from '@/api/addressbook'
import {
  commonSearchInputBox,
  commonNodeNav,
  commonHeadImg,
  commonButton,
  commonCheckbox
} from '@/components/commonAddressBook'
import {
  debounce,
  nameLastTwoWords,
  setLeft,
  removeLeft,
  pushNullUrl,
  deepCopy
} from '@/utils/comUtils'
import { mcConfirm, mcToast, mcSetTitle } from '@/utils/mcSdkUtils'

export default {
  components: {
    commonSearchInputBox,
    commonNodeNav,
    commonHeadImg,
    commonButton,
    commonCheckbox
  },
  props: {},
  data() {
    return {
      nameLastTwoWords,
      // =================================================================
      singleNodeSelected: {},
      selectedMembers: [], // 已选人员列表
      // =================================================================
      nodeNav: [], // 导航栏部门节点对象数组
      currentDepts: [], // 当前展示部门节点列表
      currentMembers: [], // 当前展示成员节点列表
      // 成员搜索相关
      searchKey: '', // 搜索人员姓名关键字
      searchMembers: [], // 当前搜索人员姓名列表
      showSelectDetail: false, // 展示选择详情
      clicking: false,
      clearConfirm: null
    }
  },
  computed: {
    computedShowDetail() {
      return this.computedSelectedText && this.multiple
    },
    computedSelectedText() {
      return this.selectedMembers.length
        ? this.selectedMembers.length === 1
          ? `已选择: ${(this.selectedMembers[0] || {}).memberName || ''}`
          : `已选择: ${this.selectedMembers.length}人`
        : ''
    },
    // 计算全选是否勾选
    compuedIsSelectedAll() {
      const members = this.searchKey ? this.searchMembers : this.currentMembers
      return members.length > 0 && members.every(item => item.selected)
    }
  },
  watch: {},
  beforeCreate() {},
  created() {
    pushNullUrl()
    setLeft(this.methodSetLeft)
  },
  beforeMount() {},
  mounted() {
    // 钉钉回退按钮监听拦截
    this.init()
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {
    removeLeft(this.methodSetLeft)
  },
  destroyed() {},
  methods: {
    //  初始化
    init() {
      this.selectedMembers = deepCopy(this.defaultSelectedMembers)
      this.searchKey = ''
      this.searchMembers = []
      this.fishnetGetRootDept().then(node => {
        this.fishnetGetsubDepts(node)
        this.fishnetGetDeptMembers(node)
        this.methodUpdateNodeNav(node)
      })
    },
    /**
     * 获取根部门
     */
    fishnetGetRootDept() {
      return new Promise((resolve, reject) => {
        API.fishnetGetRootDept({})
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    /**
     * 获取子部门
     */
    fishnetGetsubDepts(params) {
      return new Promise((resolve, reject) => {
        API.fishnetGetsubDepts({
          parentDeptId: params.deptId
        })
          .then(res => {
            const _res = (res || []).filter(item => item.tpId !== '-7')
            this.currentDepts = _res
            resolve(this.currentDepts)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    /**
     * 获取部门成员
     */
    fishnetGetDeptMembers(params) {
      return new Promise((resolve, reject) => {
        API.fishnetGetDeptMembers({
          deptId: params.deptId
        })
          .then(res => {
            this.currentMembers = (res || []).map(item => ({
              ...item,
              selected: this.selectedMembers.some(
                member => member.tpId === item.tpId
              )
            }))
            resolve(this.currentMembers)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    // 搜索人员姓名
    handlerToSearchMembers(searchKey) {
      this.searchKey = searchKey
      if (searchKey !== '') {
        debounce(this.fetchMembersByKey, 300)()
      } else {
        setTimeout(() => {
          this.searchMembers = []
        }, 301)
      }
      this.fetchMembersByKey()
    },
    fetchMembersByKey() {
      API.searchOrgMember({
        memberName: this.searchKey,
        operUserRoleTypes: 3
      }).then(res => {
        this.searchMembers = (res || []).reduce((_list, member) => {
          return _list.concat({
            ...member,
            selected: this.selectedMembers.some(
              item => item.tpId === member.tpId
            )
          })
        }, [])
      })
    },
    // 获取子部门/人员
    async handlerToGetSubNodes(node) {
      if (this.clicking) {
        return
      }
      this.clicking = true
      this.methodUpdateNodeNav(node)
      this.currentDepts = []
      this.currentMembers = []
      try {
        await this.fishnetGetsubDepts(node)
        await this.fishnetGetDeptMembers(node)
      } catch (err) {
        mcToast({ msg: err.message })
      } finally {
        this.clicking = false
      }
    },
    // 切换人员节点勾选状态
    handlerChangeMemberSelections(node) {
      if (this.multiple) {
        node.selected = !node.selected
        if (node.selected) {
          this.selectedMembers.push(node)
        } else {
          const index = this.selectedMembers.findIndex(
            item => item.tpId === node.tpId
          )
          index > -1 && this.selectedMembers.splice(index, 1)
        }
      } else {
        const selected = !node.selected
        this.currentMembers.forEach(item => {
          item.selected = item.tpId === node.tpId ? selected : false
        })
        if (this.searchKey) {
          this.searchMembers.forEach(ele => {
            ele.selected = false
          })
        }
        node.selected = selected
        if (node.selected) {
          this.selectedMembers = [node]
        } else {
          this.selectedMembers = []
        }
      }
    },
    // 全选操作
    handlerToChangeSelections() {
      const selected = !this.compuedIsSelectedAll
      const members = this.searchKey ? this.searchMembers : this.currentMembers
      members.forEach(v => {
        v.selected = selected
      })
      this.$nextTick(() => {
        members.forEach(item => {
          const index = this.selectedMembers.findIndex(
            member => member.tpId == item.tpId
          )
          if (item.selected) {
            index === -1 && this.selectedMembers.push(item)
          } else {
            index > -1 && this.selectedMembers.splice(index, 1)
          }

          if (this.searchKey) {
            const member = this.currentMembers.find(
              member => member.tpId == item.tpId
            )
            member.tpId && (member.selected = item.selected)
          }
        })
      })
    },
    // 删除已选人员
    clearMember(node) {
      const index = this.selectedMembers.findIndex(v => v.tpId === node.tpId)
      index > -1 && this.selectedMembers.splice(index, 1)
      this.currentMembers.map(v => {
        if (v.tpId === node.tpId) {
          v.selected = false
        }
      })
    },
    // 查看已选-清空
    clearData() {
      const that = this
      this.clearConfirm = this.$Dialog({
        type: 'confirm',
        title: '提示',
        content: `确认清空已选成员`,
        onConfirm() {
          that.showSelectDetail = false
          that.selectedMembers = []
          that.currentMembers.forEach(item => (item.selected = false))
          that.searchMembers.forEach(item => (item.selected = false))
        }
      }).show()
    },
    // 更新导航栏
    methodUpdateNodeNav(node, isAdd = true) {
      if (isAdd) {
        this.nodeNav.push(node)
      } else {
        let _index = this.nodeNav.findIndex(item => item.deptId === node.deptId)
        this.nodeNav = this.nodeNav.slice(0, _index + 1)
      }
    },
    // 返回导航栏
    async handlerBackToNode(node) {
      this.methodUpdateNodeNav(node, false)
      await this.fishnetGetsubDepts(node)
      await this.fishnetGetDeptMembers(node)
    },
    // 点击确认 关闭选人组件
    handlerToSubmit() {
      if (this.clicking) {
        return
      }
      this.clicking = true
      if (!this.selectedMembers.length && this.forceSelection) {
        mcToast({ msg: '请选择人员' })
        this.clicking = false
        return
      }
      const members = this.selectedMembers.map(item => ({
        userDingId: item.tpId,
        userName: item.memberName
      }))
      if (this.multiple) {
        if (members.length > this.maxMember) {
          mcToast({ msg: `人数不能超过${this.maxMember}人` })
          this.clicking = false
          return
        }
        this.close({
          members
        })
      } else {
        this.close({
          member: members[0]
        })
      }
    },
    // 回退拦截
    methodSetLeft() {
      pushNullUrl()
      if (this.showSelectDetail) {
        this.clearConfirm && this.clearConfirm.hide()
        this.showSelectDetail = false
      } else {
        if (this.showConfirm) {
          return false
        }
        this.showConfirm = true
        mcSetTitle(this.title)
        mcConfirm({ msg: '确认退出此操作吗?', closeOnPopstate: false })
          .then(btnIndex => {
            if (btnIndex === 1) {
              this.closeOnly()
              mcSetTitle(this.pageTitle)
            } else {
              this.showConfirm = false
            }
          })
          .catch(err => {
            console.log('unhandledrejection', err)
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.address-book {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 22;
  overflow-y: scroll;
}

.node-list {
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}

.tab-bottom {
  position: absolute;
  bottom: 0;
  left: 50%;
  margin-left: -12px;
  width: 24px;
  height: 3px;
  background: #006afe;
  border-radius: 2px;
}
.head-img-text {
  height: 36px;
  width: 36px;
  color: #ffffff;
  margin-right: 12px;
  background: #006afe;
  border-radius: 50%;
}
.footer {
  :deep(.c-button) {
    height: 46px;
    line-height: 46px;
    border-radius: 8px;
  }
}
</style>
